import React from 'react';
import PropTypes from 'prop-types';
import SVGIcon from 'components/SVGIcon';
import { ReactComponent as DefaultIcon } from './icon-magnifying-glass.svg';
import './index.scss';

/*
 * Type definitions
 */
const propTypes = {
    value: PropTypes.string.isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    icon: PropTypes.func,
    onChange: PropTypes.func,
};

const defaultProps = {
    type: 'text',
    placeholder: '',
    icon: DefaultIcon,
    onChange: null,
};

/*
 * Component
 */
function CustomInput({
    value,
    onChange,
    type,
    placeholder,
    icon,
}) {
    const Icon = icon;

    return (
        <div className="custom-input">
            <input
                type={type}
                placeholder={placeholder}
                onChange={onChange}
                value={value}
            />
            <SVGIcon icon={Icon} />
        </div>
    );
}

CustomInput.propTypes = propTypes;
CustomInput.defaultProps = defaultProps;

export default CustomInput;
